import {Identity} from './types/fin';

export const LAUNCHBAR_IDENTITY: Identity = {uuid: 'osLaunchpadMain', name: 'osLaunchpadMain'};
export const LAYOUTS_IDENTITY: Identity = {uuid: 'layouts-service'};
export const AUTH_IDENTITY: Identity = {...LAUNCHBAR_IDENTITY, name: 'Authentication'};

export const SYSTEM_PANEL_IDENTITY: Identity = {uuid: 'system-panel', name: 'system-panel'};
export const SYSTEM_PANEL_MANIFEST = 'https://cdn.openfin.co/system-panel/app.json';
export const SYSTEM_PANEL_RVM_VERSION: number[] = '5.8.0.0'.split('.').map((n) => parseInt(n));

export const ADMIN_UPDATE_CHANNEL = 'ADMIN_UPDATE_CHANNEL';
export enum UpdateTopics {
    ORG_SETTINGS = 'REFRESH_ORG_SETTINGS_TOPIC',
    APPLICATIONS = 'REFRESH_APPLICATIONS_TOPIC',
    SEARCH_ENGINES = 'REFRESH_SEARCH_ENGINES_TOPIC'
}

export const OAUTH_CHANNEL = 'OFD_AUTHENTICATION_CHANNEL';
export const OAUTH_TOPIC = 'OUTCOME';

// Communication between OpenFin Desktop (OFD, Notifications)
export const DESKTOP_CHANNEL = 'DESKTOP_CHANNEL';
export enum DesktopChannelActions {
    AUTHENTICATED = 'AUTHENTICATED',
    QUERY_AUTHENTICATION = 'QUERY_AUTHENTICATION'
}
